module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/payout_providers/clickworker-logo-f92b985b100da7327dbf9006ccdba81a.svg";